import { notificationsTypes } from './notifications.types';
import { handleIsAllNotificationReaded } from './notifications.utils';

const getInitialNotices = () => {
  const storedNotices = localStorage.getItem('raychat_dashboard_notices');
  if (storedNotices && storedNotices.text_fa) {
    return JSON.parse(storedNotices);
  }
  // initial state
  return {
    isAllNotificationReaded: false,
    notifications: [
      {
        id: '456995',
        text_fa:
          'آپدیت جدید رایچت ! آخرین تغییرات ورژن جدید رایچت را مشاهده کنید',
        text_en:
          'New update of Raychat! See the latest changes in the new version of Raychat.',
        isUnread: true,
        link: 'https://raychat.io/updates',
      },
    ],
  };
};

export const INITIAL_STATE = getInitialNotices();

const notificationsReducer = (state = INITIAL_STATE, action) => {
  let returnedState = {};
  switch (action.type) {
    case notificationsTypes.MARK_AS_READED:
      returnedState = {
        ...state,
        notifications: state.notifications.map((notification) => {
          return notification.id === action.payload
            ? {
                ...notification,
                isUnread: false,
              }
            : notification;
        }),
      };
      localStorage.setItem(
        'raychat_dashboard_notices',
        JSON.stringify(returnedState)
      );
      return returnedState;
    case notificationsTypes.UPDATE_IS_ALL_NOTIFICATION_READED:
      returnedState = {
        ...state,
        isAllNotificationReaded: handleIsAllNotificationReaded({
          prevState: state,
        }),
      };
      localStorage.setItem(
        'raychat_dashboard_notices',
        JSON.stringify(returnedState)
      );
      return returnedState;
    default:
      return state;
  }
};

export default notificationsReducer;
